// B2a — truthful provider view (GET /api/integration-truth). Five states; "Connected and Verified" only when a live
// provider check was recorded. SendGrid shows its level: Configured → Provider Authenticated → Delivery Verified.
import React from "react";
import StatusChip from "./StatusChip";

const LEVEL = { configured: "Configured", provider_authenticated: "Provider Authenticated", delivery_verified: "Delivery Verified" };

export const LEVEL_LABEL = LEVEL;

export function when(iso) {
  return iso ? new Date(iso).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : null;
}

function ProviderRow({ p }) {
  return (
    <li className="py-3 flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4 min-w-0" data-testid={`truth-row-${p.key}`}>
      <div className="sm:w-48 shrink-0 min-w-0">
        <div className="font-display font-semibold text-erf-dark break-words">{p.label}</div>
        <div className="text-[11px] font-mono text-erf-dark/60">{p.category}</div>
      </div>
      <div className="shrink-0"><StatusChip status={p.state} testId={`truth-state-${p.key}`} /></div>
      <div className="text-sm font-nav text-erf-dark/80 min-w-0 break-words">
        {p.level && <span className="font-semibold" data-testid={`truth-level-${p.key}`}>{LEVEL[p.level]}. </span>}
        {p.note}
        {p.last_check_at && (
          <span className="block text-[11px] font-mono text-erf-dark/60 mt-1">
            Last check {when(p.last_check_at)}: {p.last_check}
            {p.cost_usd != null ? ` · cost $${p.cost_usd}` : ""}
          </span>
        )}
      </div>
    </li>
  );
}

// Presentational: the Integrations page loads GET /integration-truth once and shares it with the adapter cards.
export default function IntegrationTruthPanel({ data, error }) {
  return (
    <section className="border border-erf-borderCream bg-white rounded-md px-4 py-3 mb-4 mx-auto w-full max-w-[1600px] box-border md:px-6"
             data-testid="integration-truth-panel" aria-labelledby="integration-truth-title">
      <h2 id="integration-truth-title" className="font-display font-semibold text-erf-dark">Provider status (verified)</h2>
      <p className="text-xs font-nav text-erf-dark/70 mt-1">
        A provider is shown as Connected and Verified only after a recorded live check. Configured keys alone are not proof.
      </p>
      {error && <p className="text-sm text-red-800 mt-2" role="alert" data-testid="integration-truth-error">{error}</p>}
      {!data && !error && <p className="text-sm text-erf-dark/60 mt-2" role="status">Loading provider status…</p>}
      {data && <ul className="divide-y divide-erf-borderCream mt-2">{data.providers.map((p) => <ProviderRow key={p.key} p={p} />)}</ul>}
    </section>
  );
}
